import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';

export default function ReportNavButton(props) {
  const {
    triggered,
    onTrigger,
  } = useNavAction('Report', props);

  return (
    <>
      <FocusableButton {...ex(['NavButton', 'ReportNavButton', { triggered }], props)} {...{ onClick: onTrigger() }}>
        <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_76_946)">
            <path d="M11 19H18V21H11V19ZM11 15H21V17H11V15ZM11 11H21V13H11V11ZM23 7H18.82C18.4 5.84 17.3 5 16 5C14.7 5 13.6 5.84 13.18 7H9C8.86 7 8.73 7.01 8.6 7.04C8.21 7.12 7.86 7.32 7.59 7.59C7.41 7.77 7.26 7.99 7.16 8.23C7.06 8.46 7 8.72 7 9V23C7 23.27 7.06 23.54 7.16 23.78C7.26 24.02 7.41 24.23 7.59 24.42C7.86 24.69 8.21 24.89 8.6 24.97C8.73 24.99 8.86 25 9 25H23C24.1 25 25 24.1 25 23V9C25 7.9 24.1 7 23 7ZM16 6.75C16.41 6.75 16.75 7.09 16.75 7.5C16.75 7.91 16.41 8.25 16 8.25C15.59 8.25 15.25 7.91 15.25 7.5C15.25 7.09 15.59 6.75 16 6.75ZM23 23H9V9H23V23Z" fill="#347AFF" />
          </g>
          <defs>
            <clipPath id="clip0_76_946">
              <rect width={24} height={24} fill="white" transform="translate(4 4)" />
            </clipPath>
          </defs>
        </svg>
        {T('Report')}
      </FocusableButton>
    </>
  );
}
